<div class="container section-top ">
  <h1>{{ title }}</h1>
  <owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide class="col-4" *ngFor="let card of cards">
      <mdb-card class="cards">
        <a
          style="text-decoration: none; padding: 0; margin: 0;"
          [routerLink]="['/book', card.id]"
        >
          <img mdbWavesEffect alt="Responsive image" [src]="card.image" />
        </a>
        <mdb-card-body class="border border-warning">
          <mdb-card-title>
            <h4 class="text-center pt-2">{{ card.title }}</h4>
          </mdb-card-title>
        </mdb-card-body>
      </mdb-card>
    </ng-template>
  </owl-carousel-o>
</div>
